import { createContext, useContext, useMemo } from "react";
import { useApi } from "@/lib/api";

export const ConsoleCtx = createContext({ token: null, onExpired: () => {} });

export function useConsoleApi() {
  const api = useApi();
  const { token, onExpired } = useContext(ConsoleCtx);
  return useMemo(() => {
    const call = (method) => (url, ...args) => {
      const cfgIdx = method === "get" || method === "delete" ? 0 : 1;
      const cfg = { ...(args[cfgIdx] || {}) };
      cfg.headers = { ...(cfg.headers || {}), "X-Console-Token": token };
      args[cfgIdx] = cfg;
      return api[method](url, ...args).catch((e) => { if (e?.response?.status === 401) onExpired(); throw e; });
    };
    return { get: call("get"), post: call("post"), patch: call("patch"), delete: call("delete") };
  }, [api, token, onExpired]);
}
